import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Accordion } from '@frontend/design-system';
import { BookingSiteAppointmentLeadTimeSetting } from './BookingSiteAppointmentLeadTimeContent/AppointmentLeadTimeSetting';
import { BookingSiteLinks } from './BookingSiteLinks';
import { bookingSiteSetupBasePageTrackingIds } from './trackingIds';

const { bookingLinksAccordion, appointmentBookingAccordion } = bookingSiteSetupBasePageTrackingIds;

export const BookingSiteSetup = () => {
  const { t } = useTranslation('schedule-settings');

  const { isScheduleV3FlagEnabled } = SchedulerV3.Helpers.useGetSchedulerV3FeatureFlagDetails();

  return (
    <>
      {isScheduleV3FlagEnabled ? (
        <Accordion css={{ maxWidth: 700 }}>
          <Accordion.Item value='booking-site-links' trackingId={bookingLinksAccordion}>
            <Accordion.Header>{t('Booking Links')}</Accordion.Header>
            <Accordion.Body css={{ padding: 0, borderRadius: 0 }}>
              <BookingSiteLinks />
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item value='booking-site-appointment-settings' trackingId={appointmentBookingAccordion}>
            <Accordion.Header>{t('Appointment Booking')}</Accordion.Header>
            <Accordion.Body css={{ background: theme.colors.white, padding: theme.spacing(2, 3, 5, 3) }}>
              <BookingSiteAppointmentLeadTimeSetting />
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      ) : (
        <BookingSiteLinks isAccordionContent={false} />
      )}
    </>
  );
};
